// The shape of a lesson as the site renders it. Lessons themselves are written
// on the server now (see serverLesson.js), for the website and the app alike.

const S = (v) => String(v || '').trim()

export const parseObj = (raw) => {
  let s = String(raw || '').replace(/```json/gi, '').replace(/```/g, '').trim()
  const a = s.indexOf('{'), b = s.lastIndexOf('}')
  if (a >= 0 && b > a) s = s.slice(a, b + 1)
  try { return JSON.parse(s) } catch { return null }
}
const pairs = (arr) => (Array.isArray(arr) ? arr : []).map(x => ({ tr: S(x?.tr), en: S(x?.en) })).filter(p => p.tr)

// Normalise a generated lesson into the shape StudentLessonView renders.
export const cleanLesson = (o, code, name, level) => {
  if (!o) return null
  const sections = (Array.isArray(o.sections) ? o.sections : []).map(sec => {
    const ex = sec?.exercise
    const items = Array.isArray(ex?.items) ? ex.items.map(it => ({ q: S(it?.q), a: S(it?.a), options: Array.isArray(it?.options) ? it.options.map(S).filter(Boolean) : undefined })).filter(it => it.q || it.a) : []
    // Paradigm table: columns + rows of strings (rendered by StudentLessonView).
    const tb = sec?.table
    const table = tb && Array.isArray(tb.rows) && tb.rows.length
      ? { columns: (Array.isArray(tb.columns) ? tb.columns : []).map(S), rows: tb.rows.map(r => (Array.isArray(r) ? r : []).map(S)).filter(r => r.length) }
      : undefined
    return {
      kind: ['concept', 'vocab', 'paradigm', 'patterns', 'practice'].includes(sec?.kind) ? sec.kind : (items.length ? 'practice' : 'concept'),
      title: S(sec?.title) || 'Section', note: S(sec?.note) || undefined, table,
      words: pairs(sec?.words), sentences: pairs(sec?.sentences),
      exercise: items.length ? { type: S(ex?.type) || 'translate', prompt: S(ex?.prompt), items } : undefined,
    }
  }).filter(s => s.words.length || s.sentences.length || s.exercise || s.note || s.table)
  const r = o.reading
  const reading = S(r?.text) ? { title: S(r?.title) || 'Reading', text: S(r.text), glossary: pairs(r?.glossary), questions: (Array.isArray(r?.questions) ? r.questions : []).map(q => ({ q: S(q?.q), a: S(q?.a) })).filter(q => q.q) } : undefined
  const d = o.dialogue
  const dLines = (Array.isArray(d?.lines) ? d.lines : []).map(l => ({ who: S(l?.who), tr: S(l?.tr), en: S(l?.en) })).filter(l => l.tr)
  const dialogue = dLines.length ? { title: S(d?.title) || 'Mini dialogue', lines: dLines } : undefined
  const speaking = (Array.isArray(o.speaking) ? o.speaking : []).map(S).filter(Boolean)
  if (sections.length === 0 && !reading && !dialogue) return null
  return { title: S(o.title) || 'Lesson', level: S(o.level) || level, goal: S(o.goal), language: code, languageName: name, sections, reading, dialogue, speaking: speaking.length ? speaking : undefined }
}
